/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    RenewalSummaryHeader: {
        id: 'cep.components.sgRenewalSummaryPage.Header',
        defaultMessage: 'Your renewal summary'
    },
    CancelLabel: {
        id: 'cep.components.sgRenewalSummaryPage.CancelLabel',
        defaultMessage: 'Cancel'
    },
    BackToMainLabel: {
        id: 'cep.components.sgRenewalSummaryPage.BackToMainLabel',
        defaultMessage: 'Back to main page'
    },
    BackToOriginalOfferLabel: {
        id: 'cep.components.sgRenewalSummaryPage.BackToOriginalOfferLabel',
        defaultMessage: 'Back to original renewal'
    },
    GoBackLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.GoBackLabel_WOC3143',
        defaultMessage: 'Go back'
    },
    RenewalPageIpidLink: {
        id: 'cep.components.sgRenewalSummaryPage.Ipid',
        defaultMessage: 'Insurance Product Information Document'
    },
    CashCheque1: {
        id: 'cep.components.sgRenewalSummaryPage.CashCheque1',
        defaultMessage: 'Due to your chosen payment method we are able to process this policy renewal offline only.'
    },
    CashCheque2: {
        id: 'cep.components.sgRenewalSummaryPage.CashCheque2',
        defaultMessage: 'Please contact us on {number} for assistance in renewing your policy on the terms below.'
    },
    PrivateMotorComprehensiveCoverLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.PrivateMotorComprehensiveCoverLabel_WOC3143',
        defaultMessage: 'At Saga we have 3 Comprehensive cover levels that can be tailored to suit your needs and budget: Standard, Select and Plus. If you’d like to discuss the different options call us on {phoneNumber1} and we will help you find the cover that is right for you. If you require Third Party Only or Third Party, Fire and Theft cover, you will need to call us on {phoneNumber2}'
    },
    PrivateHomeComprehensiveCoverLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.PrivateHomeComprehensiveCoverLabel_WOC3143',
        defaultMessage: 'At Saga we have 2 cover levels that can be tailored to suit your needs and budget: Saga Select and Saga Plus. If you’d like to discuss the different options call us on {phoneNumber1} and we will help you find the cover that is right for you.'
    },
    ClickingContinueLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.ClickingContinueLabel_WOC3143',
        defaultMessage: 'By clicking Continue, you confirm that you have read the above'
    },
    ConfirmRenewalLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.ConfirmRenewalLabel_WOC3143',
        defaultMessage: 'By proceeding with your renewal, you are agreeing that you have read all of the renewal documents and that all details are correct.'
    },
    RenewalDocumentLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.RenewalDocumentLabel_WOC3143',
        defaultMessage: 'Renewal document'
    },
    ShopAroundLessThanThreeLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.ShopAroundLessThanThreeLabel_WOC3143',
        defaultMessage: 'Please review your level of cover to ensure it still meets your needs. You can find this information in your documents under the \'My documents\' section of your customer account. You may be able to get the insurance cover you want at a better price if you shop around. Please remember to make sure the other cover is comparable to your Saga policy, which includes many great features and benefits.'
    },
    ShopAroundMoreThanFourLabel_WOC3143: {
        id: 'cep.components.sgRenewalSummaryPage.ShopAroundMoreThanFourLabel_WOC3143',
        defaultMessage: 'Please review your level of cover to ensure it still meets your needs. You can find this information in your documents under the \'My documents\' section of your customer account. You have been with us for a number of years. You may be able to get the insurance cover you want at a better price if you shop around. Please remember to make sure the other cover is comparable with your Saga policy, which includes many great features and benefits.'
    },
});
